import { FloatingPortal, useMergeRefs } from '@floating-ui/react'
import { clsx } from 'clsx'
import { forwardRef } from 'react'
import { useTooltipContext } from './hooks'
import { tooltipStyle } from './index.css'

export const TooltipContent = forwardRef<
  HTMLDivElement,
  React.HTMLProps<HTMLDivElement>
>(({ style, ...props }, propRef) => {
  const context = useTooltipContext()
  const ref = useMergeRefs([context.refs.setFloating, propRef])

  if (!context.open) return null

  return (
    <FloatingPortal>
      <div
        ref={ref}
        style={{
          ...context.floatingStyles,
          ...style,
        }}
        {...context.getFloatingProps(props)}
        className={clsx(tooltipStyle, props.className)}
      />
    </FloatingPortal>
  )
})
